export enum ERolePermission {
  HEAD_OF_ENGINEERING = 'HOE',
  SITE_ENGINEER = 'SE',
  TEMPORARY_WORK_COORDINATOR = 'TWC',
  PROJECT_MANAGER = 'TM',
  // (MISSING IN DB) ICE = 'ICE',
  ICE_ADMINISTRATOR = 'ICE_ADM',
  ICE_AUTHORISED_REPRESENTATIVE = 'ICE_IAR',
  REVIEWER_AUTHORISED_REPRESENTATIVE = 'REV_IAR',
  DESIGNER = 'DEG',
  ADMINISTRATOR = 'ADM',
  LAMBETH_ENGINEERING_MANGER = 'LEM',
  ENGINEERING_MANAGER = 'EM',
  TEMPORARY_WORK_COORDINATOR_FOR_MINOR_WORKS = 'TWCM',
  DESIGNER_ADMINISTRATOR = 'DA',
  DESIGNER_AUTHORISED_REPRESENTATIVE = 'DAR',
  // (MISSING IN DB) GAMMON_INTERNAL_USER = 'GIU',
  CLIENT = 'CLI',
  // (MISSING IN DB) REGULATORY_AUTHORITY = 'RA',
  DESIGNERS_SECRETARY = 'SEC',
  VIEWER = 'TWV',
  IMS_TEAM_OR_SYSTEM_DEVELOPER = 'IDT',
  OPERATIONS_SECRETARY = 'OS',
  // (MISSING IN DB) QUALIFIED_PERSON = 'QP',
  // (MISSING IN DB) GEOTECHNICAL_ENGINEER = 'GE',
  ALL_DESIGNERS = 'DEG_ALL',
}

export enum EGeneralPermission {
  USER_SETTING = 'US',
  READ_ONLY = 'RO',
  SIGNATURE_MAINTENANCE = 'SM',
  NOMINATE_TWC_LIST = 'NTWCL',
  PROPOSE_AND_EDIT_TWC_LIST = 'PETWCL',
  DAILY_SUMMARY = 'DS',
  // (MISSING IN DB) VIEW_TRAINING_STATUS = 'VTS',
  // (MISSING IN DB) MANAGE_TEAM_FOR_SITE = 'TEAM_SITE',
  // (MISSING IN DB) MANAGE_TEAM_FOR_DESIGNER = 'TEAM_DES',
  // (MISSING IN DB) MANAGE_TEAM_FOR_ICE = 'TEAM_ICE',
}

export enum EPersonalProfilePermission {
  QUALIFICATION = 'PP_QUAL',
}
export enum EMasterSchedulePermission {
  MODIFY_MASTER_SCHEDULE = 'MMS',
  MODIFY_DESIGN_BRIEF_LIST = 'MDBL',
  MODIFY_MODIFICATION_REQUEST_LIST = 'MMRL',
  // (MISSING IN DB) ASSIGN_EXTERNAL_ACCESS_PERMISSION = 'T1_EXTACC',
  MODIFY_ON_GANTT_CHART = 'T1_GANTT',
  T1_BATCH_ADD = 'T1_BATCH_ADD',
}

export enum EFileManagementPermission {
  UPLOAD_RELEASED_FOR_CONSTUCTION_DRAWING = 'URFCD',
  UPLOAD_ICE_DESIGN_CHECK_CERTIFICATES = 'UDCC',
  UPLOAD_RELEASED_FOR_CONSTRUCTION_T3 = 'URFCT3',
  UPLOAD_ICE_CONSTRUCTION_CHECK_CERTIFICATES = 'UCCC',
  UPLOAD_CLIENT_DESIGN_CHECK_CERTIFICATES = 'UCDCC',
  UPLOAD_CLIENT_CONSTRUCTION_CHECK_CERTIFICATES = 'UCCCC',
}

export enum EDesignBriefPermission {
  INITATE = 'T2_INI',
  UPLOAD_ATTACHMENT = 'T2_UATT',
  ISSUE = 'T2_ISS',
  COMMENT = 'T2_DC',
  RESPONSE = 'T2_SOR',
  // ENDORSED = 'T2_DE', // No longer support endorsed by designer
  // ENDORSED_NO_EMAIL = 'T2_DENE', // No longer support endorsed by designer
  // CANCEL = 'T2_CAL', // No longer support
  // UNDO_CANCEL = 'T2_UCAL', // No longer support
}

export enum EDesignBriefEmailNotificationPermission {
  WHEN_ISSUED = 'T2_EN_I',
  // (MISSING IN DB) WHEN_ISSUED_DESIGNER_NOT_EXISTS = 'T2_EN_I_DNE',
  WHEN_ENDORSED = 'T2_EN_E',
  WHEN_COMMENTED = 'T2_EN_C',
  WHEN_RESPONSED = 'T2_EN_R',
}

export enum ETransmittalPermission {
  // (MISSING IN DB) VIEW = 'TRA_V',
  // (MISSING IN DB) PRINT = 'TRA_P',
  // (MISSING IN DB) DELETE = 'TRA_D',
  CREATE_OR_UPDATE = 'TRA_GU',
  ENDORSE = 'TRA_E',
  COMMENT = 'TRA_CC',
  RESPONSE = 'TRA_RC',

  DESIGNER_UPDATE = 'TRA_U',
  // (MISSING IN DB) DESIGNER_APPROVE = 'TRA_A',
  // (MISSING IN DB) DESIGNER_NOTIFICATION = 'TRA_N',

  // (MISSING IN DB) SITE_OPERATION_APPROVE = 'TRA_ASO',
  // (MISSING IN DB) SITE_OPERATION_NOTIFICATION = 'TRA_NSO',
  // (MISSING IN DB) SITE_OPERATION_COMMENT = 'TRA_SOC',,
  // (MISSING IN DB) SITE_OPERATION_EMAIL_NOTIFICATION_WHEN_COMMENTED = 'TRA_SOC',

  // (MISSING IN DB) ICE_UPDATE = 'TRA_UICE',
  // (MISSING IN DB) ICE_APPROVE = 'TRA_AICE',
  // (MISSING IN DB) ICE_NOTIFICATION = 'TRA_NICE',
}

export enum ETransmittalEmailNotificationPermission {
  WHEN_ENDORSED = 'TRA_EN_E',
  WHEN_REQUEST_ENDORSEMENT = 'TRA_EN_ER',
  WHEN_COMMENTED = 'TRA_EN_CI',
}

export enum ESiteTransmittalPermission {
  CREATE_OR_UPDATE = 'STR_GU',
  ENDORSE = 'STR_EE',
  RESPONSE = 'STR_RC',
  PREPARE_APPROVAL = 'STR_AP',
  PREPARE_REVIEW = 'STR_REV',
  // (MISSING IN DB) RESPONSE_TO_LIR = 'STR_RLIR',
  // (MISSING IN DB) CLIENT_COMMENT = 'STR_CLT_CC',
  // (MISSING IN DB) CLIENT_EMAIL_NOTIFICATION_WHEN_RESPONSED = 'STR_CLT_EN_RI',
  ICE_COMMENT = 'STR_ICE_CC',
  // (MISSING IN DB) ICE_EMAIL_NOTIFICATION_WHEN_RESPONSED = 'STR_ICE_EN_RI',
}

export enum ESiteTransmittalEmailNotificationPermission {
  WHEN_ENDORSED = 'STR_EN_E',
  WHEN_ENDORSED_CC = 'STR_EN_E_CC',
  WHEN_REQUEST_ENDORSEMENT = 'STR_EN_ER',
  // (MISSING IN DB) WHEN_COMMENTED = 'TW_STR_EN_CI',
}

export enum EIceTransmittalPermission {
  SEND_APPROVAL = 'ICE_AP',
  RELEASE_FOR_CONSTRUCTION = 'ICE_RL',
  // (MISSING IN DB) PREPARE_COMMENT = 'ICE_PCM',
  // (MISSING IN DB) ISSUE_COMMENT = 'ICE_ICM',
  // (MISSING IN DB) REPLY_COMMENT = 'ICE_RCM',
}

export enum EIceTransmittalEmailNotificationPermission {
  WHEN_APPROVED = 'ICE_EN_AP',
  WHEN_RELEASE_FOR_CONSTRUCTION_ = 'ICE_EN_RL',
  // (MISSING IN DB) WHEN_COMMENTED = 'ICE_EN_CM',
}

export enum EReviewerTransmittalPermission {
  RT_COMMENT = 'RTR_RREP_CC',
  RT_REPLY = 'RTR_RC',
}
export enum EModificationRequestPermission {
  DESIGNER_COMMENT = 'T3_DC',
  DESIGNER_APPROVE = 'T3_DE',
  DESIGNER_COMMENT_RESPONSE = 'T3_SOR',

  ICE_APPROVE = 'T3_ICEE',
  ICE_COMMENT = 'T3_ICEC',
  ICE_COMMENT_RESPONSE = 'T3_IIC',

  REV_APPROVE = 'T3_REVE',
  REV_COMMENT = 'T3_REVC',
  REV_COMMENT_RESPONSE = 'T3_IIC',

  INITATE = 'T3_INI',
  ISSUE_TO_DESIGNER = 'T3_ISS',
  ISSUE_TO_TWC = 'T3_ITTWC',
  ISSUE_TO_ICE = 'T3_ITI',
  UPLOAD_RELEASED_FOR_CONSTRUCTION = 'URFCT3',

  RELEASE_FOR_CONSTRUCTION = 'T3_RFC',
  ALLOW_CHANGE_ICE = 'T3_CICE', // NOT EXISTS IN 1.0 AccessRight.cs
}

export enum EModificationRequestEmailNotificationPermission {
  WHEN_ICE_COMMENT_ISSUED = 'T3_EN_ICE_CI',
  WHEN_ICE_COMMENT_RESPONSE = 'T3_EN_ICE_CR',
  WHEN_DESIGNER_COMMENT_RESPONSE = 'T3_ENCR',
  WHEN_DESIGNER_COMMENT_ISSUED = 'T3_EN_CI',
  WHEN_DESIGNER_APPROVED = 'T3_ENDA',
  WHEN_ISSUED_TO_DESIGNER = 'T3_ENIOD',
  WHEN_ISSUED_TO_ICE = 'T3_ENITICE',
  WHEN_ICE_APPROVED = 'ICE_EN_ICEA',
  WHEN_ISSUED_TO_TWC = 'T3_EN_ITTWC',
}

export enum EConstructionRemovalCertPermission {
  INITATE = 'T4_INI',
  // (MISSING IN DB) UPLOAD_ATTACHMENT = 'T4_UATT',
  TWC_COMMENT = 'T4_CMM',
  TWC_ENDORSED = 'T4_END',
  TWCM_ENDORSED = 'T4_MEND',
  // (MISSING IN DB) ICE_ENDORSED = 'T4_IEND',
  // (MISSING IN DB) PM_ENDORSED = 'T4_PEND',
  ISSUE_TO_ICE = 'T4_IICE',
  ICE_APPROVAL = 'T4_ICEA',
  CANCEL = 'T4_CAN',
  UPLOAD_ICE_CERT = 'T4_UICEC',
  T4_CREATE_REVISION = 'T4_NREV', // NOT EXISTS IN 1.0 AccessRight.cs
}

export enum EConstructionRemovalCertEmailNotificationPermission {
  WHEN_COMMENTED = 'T4_EN_C',
  WHEN_RESPONSED = 'T4_EN_R',
  WHEN_REQUEST_ICE_APPROVAL = 'T4_EN_RI',
  // (MISSING IN DB) WHEN_ICE_APPROVED = 'T4_EN_IA',
  WHEN_ISSUED = 'T4_EN_IS',
}

export enum ETwcTwcmApplicationPermission {
  // (MISSING IN DB) PM_APPROVE = 'PM_TWC',
  EM_APPROVE = 'EM_TWC',
  INITATE_TWC = 'TWC_INI',
  ISSUE_TWC = 'TWC_ISS',
  APPROVE_TWC = 'TWC_APP',
  DOWNLOAD_CV = 'TWC_CV',
  REVOKE = 'TWC_RV',
}

export enum ETunnelWorksPermitPermission {
  CREATE_OR_UPDATE = 'T5_CU',
  // (MISSING IN DB) COMMENT_ISSUE = 'T5_C_I',
  // (MISSING IN DB) COMMENT_RESPONSE = 'T5_C_R',
  CREATE_OR_UPDATE_T5S_SLOPE_WORKS_PERMIT = 'T5S_CU', // NOT EXISTS IN 1.0 AccessRight.cs
  // (MISSING IN DB) EMAIL_WHEN_COMMENT_ISSUE = 'T5_C_EN_I',
  // (MISSING IN DB) EMAIL_WHEN_COMMENT_RESPONSE = 'T5_C_EN_R',
}

export enum EUdfPermission {
  DEFINE = 'UDF_DF',
}

export enum EPermission {
  ICE_AUTHORISED_REPRESENTATIVE = 'ICE_AR', // NOT EXISTS IN 1.0 AccessRight.cs
  // SYS_MAINTENANCE = 'SYSADMIN', // NOT EXISTS IN 1.0 AccessRight.cs
  PROJECT_DESIGN_MANAGER = 'PDM', // NOT EXISTS IN 1.0 AccessRight.cs // User Type PDM?
  PLANNING_MANAGER = 'PLANM', // NOT EXISTS IN 1.0 AccessRight.cs // For signature download page?
  DIRECTOR = 'DIR', // NOT EXISTS IN 1.0 AccessRight.cs // For signature download page? Form type DIR?
  DESIGNER_TRANSMITTAL_RFC_BY_TWC = 'TRA_RFC', // NOT EXISTS IN 1.0 AccessRight.cs
  RSS_NOTIFICATION_GROUP = 'RSS', // NOT EXISTS IN 1.0 AccessRight.cs
  WEB_MASTER = 'GWM', // Newly created in 2.0
  MYGEMS_EDIT = 'MYGEMS_EDIT',
  MOBILE_USAGE_VIEWER = 'MOBILEUSAGE',
}

export const CreateDesignerTransmittalPermissions: string[] = [
  ERolePermission.ALL_DESIGNERS,
  ETransmittalPermission.DESIGNER_UPDATE,
];
